import React, { useMemo, useState, useRef } from 'react';
import { BigidMenu, TertiaryButton } from '@bigid-ui/components';
import { LanguageContainer } from '../../state/languageContainer';
import { TenantContainer } from '../../state/tenantContainer';
import { BigidChevronDownIcon } from '@bigid-ui/icons';

export const LanguagesMenu = () => {
  const buttonRef = useRef(null);
  const { language, availableLanguages, setLanguage } = LanguageContainer.useContainer();
  const { tenant } = TenantContainer.useContainer();
  const [openMenu, setOpenMenu] = useState(false);

  const localeList = useMemo(() => tenant.locales?.map(({ code }) => code), [tenant.locales]);

  const menuItems = useMemo(
    () =>
      availableLanguages
        ?.filter(({ value }) => localeList?.includes(value))
        .map(({ label, value }) => ({
          id: value,
          label,
          onClick: () => {
            document.documentElement.setAttribute('lang', value);
            localStorage.setItem('lang', value);
            setLanguage(value);
          },
        })),
    [availableLanguages, localeList],
  );

  const languageName = useMemo(
    () => availableLanguages?.find(item => item.value === language)?.label,
    [availableLanguages, language],
  );

  return (
    <div ref={buttonRef}>
      <TertiaryButton
        size="medium"
        text={languageName}
        onClick={() => setOpenMenu(true)}
        endIcon={<BigidChevronDownIcon />}
        dataAid="select_language_button"
      />
      <BigidMenu
        open={openMenu}
        anchorEl={buttonRef.current || undefined}
        items={menuItems}
        onMenuClose={() => setOpenMenu(false)}
        dataAid="select_language_menu"
      />
    </div>
  );
};
